<ion-header class="absolute transparent">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>
<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <div class="bg-header" [ngClass]="'bg-inner-'+userService.theme">
            <div class="wrap-logo">
                <img class="side-logo" [src]="userService.companyLogo">
                <div class="title">{{'__LEADERBOARD_TITLE__' | translate}}</div>
            </div>
            <div class="table-header">
                <div class="elem">{{'__LEADERBOARD_COLUMN_POSITION__' | translate}}</div>
                <div class="elem left">{{'__LEADERBOARD_COLUMN_NAME__' | translate}}</div>
                <div class="elem">{{'__LEADERBOARD_COLUMN_ROLE__' | translate}}</div>
                <div class="elem bg-d2 bg-border-left">{{'__LEADERBOARD_COLUMN_PRE_WORK__' | translate}}</div>
                <div *ngIf="false" class="bg-2 elem">
                    <div class="line-1">{{'__LEADERBOARD_COLUMN_ENABLEMENT_SESSION__' | translate}}</div>
                    <div class="line-2">
                        <div class="green box">1</div>
                        <div class="raspberry box">2</div>
                        <div class="blue box">3</div>
                        <div class="purple box">4</div>
                    </div>
                </div>
                <div class="elem bg-2"><span>{{'__LEADERBOARD_COLUMN_LIVE_EVENT__' | translate}}</span></div>
                <div class="elem bg-d2">{{'__LEADERBOARD_COLUMN_POST_WORK__' | translate}}</div>
                <div class="elem bg-d1 bg-border-right">{{'__LEADERBOARD_COLUMN_SOCIAL__' | translate}}</div>
                <div *ngIf="false" class="bg-4 elem desktop-only">{{'__LEADERBOARD_COLUMN_SIMULATION__' | translate}}</div>
                <div *ngIf="false" class="bg-4 elem mobile-only">{{'__LEADERBOARD_COLUMN_SIM__' | translate}}</div>
                <div class="elem">{{'__LEADERBOARD_COLUMN_TOTAL__' | translate}}</div>
            </div>
        </div>
        <div class="shadow-container" *ngIf="!leaderboardData">
            <app-skeleton-leaderboard *ngFor="let el of ['50%','60%','40%','45%','50%','60%','40%','45%','50%','60%']; let i = index; let even = even"
                                      [ngClass]="{ even: even }" [even]="even" [width]="el"></app-skeleton-leaderboard>
        </div>
        <div class="shadow-container" *ngIf="!!leaderboardData">
            <div class="grid-line" *ngFor="let el of leaderboardData; let i = index; let even = even"
                 [ngClass]="{ even: even }">
                <div class="index" [ngClass]="{ dark: even }">{{i+1}}</div>
                <div class="left">{{el.full_name}}</div>
                <div class="location">{{el.location}}</div>
                <div>{{el.pre_event}}</div>
                <div *ngIf="false" class="green no-border">{{el.session1}}</div>
                <div *ngIf="false" class="raspberry no-border">{{el.session2}}</div>
                <div *ngIf="false" class="blue no-border">{{el.session3}}</div>
                <div *ngIf="false" class="purple no-border">{{el.session4}}</div>
                <div>{{el.total_quiz}}</div>
                <div>{{el.post_event}}</div>
                <div>{{el.social}}</div>
                <div *ngIf="false">{{el.sim}}</div>
                <div class="bold">{{el.total}}</div>
            </div>
        </div>
    </div>
    <app-footer-logo [veeam]="true"></app-footer-logo>
</ion-content>
